import Logger from '../lib/logger';
import SideCartMainItem from './SideCartMainItem';
import SideCartSelectedItem from './SideCartSelectedItem';
import { DEFAULT_BUNDLE_DATA } from '../lib/constants';
import { deepClone, handlize, money } from '../lib/util.functions';

class BundlerSideCart extends HTMLElement {
  #NAME = 'BundlerSideCart'
  #currentData = {...DEFAULT_BUNDLE_DATA}
  #componentItems = []
  body
  #toggleBtns
  #timeThreshhold = 100
  #swipeThreshhold = 50
  #swipeStart = { x: 0, y: 0 }
  #swipeTimeBegin = 0

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.body = this.querySelector('[data-body]');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#toggleBtns = this.querySelectorAll('.bundler-side-cart__header .theme-button--small');
    this.countEl = this.querySelector('[data-count]');
    this.subtotalEl = this.querySelector('[data-subtotal-price]');
    this.itemContainers = this.querySelectorAll('[data-item-container-type] [data-items]');
    this.titles = this.querySelectorAll('side-cart-container-title');
    //
    this.#toggleBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.dataset.open = !(this.dataset.open === 'true');
      })
    });
    //
    this.firstElementChild.addEventListener('touchstart', (e) => this.#onTouchStart(e));
    this.firstElementChild.addEventListener('touchend', (e) => this.#onTouchEnd(e));
  }

  static get observedAttributes() {
    return ['data-step'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-step') {
      const index = parseInt(newValue) - 1;
      this.titles?.forEach((el,i) => {
        el.dataset.reveal = i === index;
      })
    }
  }

  update(bundleData, totalItems, totalPrice) {
    Logger.info(`${this.#NAME} > update`, bundleData, totalItems, totalPrice);
    //
    this.#currentData = deepClone(bundleData);
    this.countEl.dataset.count = totalItems;
    this.subtotalEl.textContent = money(totalPrice);
    //
    this.#currentData.addedComponentReference.forEach((variantId, i, ids) => {
      let card = document.querySelector(`bundler-step[data-bundler-step="${this.#currentData.addedComponentSteps[i]}"] product-card[data-product-id="${this.#currentData.addedComponentProductIds[i]}"][data-group-index="${this.#currentData.addedComponentGroupIndex[i]}"]`);
      if (card && card.dataset.onlyForProductId) {
        card = document.querySelector(`bundler-step[data-bundler-step="${this.#currentData.addedComponentSteps[i]}"] product-card[data-product-id="${this.#currentData.addedComponentProductIds[i]}"][data-group-index="${this.#currentData.addedComponentGroupIndex[i]}"][data-only-for-product-id="${this.#currentData.addedComponentOnlyForProductIds[i]}"]`);
      }
      /* console.log(variantId, i, card); */
      const itemClass = card?.dataset.groupIndex === '1' ? SideCartMainItem : SideCartSelectedItem;
      let container = this.itemContainers[this.#currentData.addedComponentSteps[i] - 1].querySelector(`[data-row="${card?.dataset.groupIndex}"]`);
      let price = (this.#currentData.addedComponentPrices[i] * this.#currentData.addedComponentQuantities[i]) * this.#currentData.quantity;
      //
      if (!container) {
        const div = document.createElement('DIV');
        div.dataset.row = card?.dataset.groupIndex;
        div.style.gridRow = card?.dataset.groupIndex;
        this.itemContainers[this.#currentData.addedComponentSteps[i] - 1].append(div);
        container = div;
      }
      //
      if (this.#currentData.addedComponentDiscounts[i]) {
        price = this.#currentData.addedComponentDiscounts[i].map((p,j) => !j ? p : p * (this.#currentData.addedComponentQuantities[i] - 1))
                .reduce((a,b) => a + b, 0);
      }
      //
      this.#updateComponentItem(itemClass, container, {
        variantId, 
        price,
        title: this.#currentData.addedComponentTitles[i],
        quantity: this.#currentData.addedComponentQuantities[i] * this.#currentData.quantity,
        image: this.#currentData.addedComponentImages[i] || this.dataset.placeholderUrl,
        options: this.#currentData.addedComponentOptions[i] || undefined,
        productId: this.#currentData.addedComponentProductIds[i],
        multiple: this.#currentData.addedComponentMultiple[i],
        customText: this.#currentData.addedComponentCustomText[i],
        bundleIndex: i,
        groupIndex: this.#currentData.addedComponentGroupIndex[i],
        connected: card?.dataset.connected === 'true',
        step: this.#currentData.addedComponentSteps[i],
        onlyForProductId: card?.dataset.onlyForProductId
      }) 
    });
    //
    this.#removeDeletedItems();
  }

  #updateComponentItem(ElementClass, container, { variantId, price, title, quantity, image, options, productId, multiple, customText, bundleIndex, groupIndex, connected, step, onlyForProductId }) {
    Logger.info(`${this.#NAME} > #updateComponentItem`, options, quantity, variantId, step, bundleIndex, groupIndex);
    const items = this.#componentItems.filter(el => el.dataset.variantId === variantId && el.step === step && el.dataset.groupIndex == groupIndex);
    let componentItem = items.length ? (items.length > 1 ? this.#componentItems.find(el => el.dataset.bundleIndex == bundleIndex) : items[0]) : undefined;
    if (!componentItem) {
      componentItem = new ElementClass({ variantId, price, title, quantity, image, options, productId, multiple, customText, bundleIndex, groupIndex, connected, step, onlyForProductId });
      container.appendChild(componentItem);
      this.#componentItems.push(componentItem);
    } else {
      if (componentItem.dataset.variantId !== variantId) componentItem.dataset.variantId = variantId;
      if (componentItem.dataset.price != price) componentItem.dataset.price = price;
      if (componentItem.dataset.title !== handlize(title)) {
        componentItem.dataset.title = handlize(title);
        componentItem.querySelector('[data-title]').textContent = title;
      } 
      if (componentItem.dataset.quantity != quantity) componentItem.dataset.quantity = quantity;
      if (componentItem.dataset.image !== image) componentItem.dataset.image = image;
      if (componentItem.dataset.options !== options) componentItem.dataset.options = options;
      if (componentItem.dataset.customText !== customText) componentItem.dataset.customTexts = customText;
      if (componentItem.dataset.bundleIndex != bundleIndex) componentItem.dataset.bundleIndex = bundleIndex;
    }
  }

  #removeDeletedItems() {
    let itemId;
    this.#componentItems.forEach((item, i) => {
      itemId = this.#currentData.addedComponentReference.find(
        (variantId, i) => item.dataset.variantId === variantId && this.#currentData.addedComponentSteps[i] === item.step && this.#currentData.addedComponentGroupIndex[i] == item.dataset.groupIndex);
      if (!itemId) {
        this.#componentItems[i] = null;
        item.remove();
        item = null;
      }
    });
    this.#componentItems = this.#componentItems.filter(el => el);
    
  }

  #onTouchStart(e) {
    if (window.innerWidth < 960) {
      this.#swipeStart = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      this.#swipeTimeBegin = e.timeStamp;
    }
  }

  #onTouchEnd(e) {
    if (window.innerWidth < 960 && 
      (this.dataset.open === 'false' || (e.target !== this.body && this.body.querySelector(`.${e.target.className}`) === null))) 
    {
      const amount = this.#swipeStart.y - e.changedTouches[0].clientY;
      const time = e.timeStamp - this.#swipeTimeBegin;
      if (time > this.#timeThreshhold && Math.abs(amount) >= this.#swipeThreshhold) {
        this.#swipeStart = { x: 0, y: 0 };
        this.#swipeTimeBegin = 0;
        this.dataset.open = !(this.dataset.open === 'true');
      }
    }
  }
}

customElements.define('bundler-side-cart', BundlerSideCart);